import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import SharedCartPreview from "../pages/Cart/SharedCartPreview";
import Footer from "../components/Footer";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga4";

const CustomerLayout = () => {
  const location = useLocation();

  useEffect(() => {
    const pixelId = "1075690678030109";
    ReactPixel.init(pixelId);

    // Track initial page view
    ReactPixel.pageView();
  }, []);

  useEffect(() => {
    const measurementId = "G-P00KV62RCW";
    ReactGA.initialize(measurementId);
  }, []);

  useEffect(() => {
    // Track page view on route change
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return (
    <>
      <Navbar />
      <Outlet />
      <SharedCartPreview />
      <Footer />
    </>
  );
};

export default CustomerLayout;
